import React from 'react'
import { SVGProps } from 'react'

const HeartFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M8 14.9189C7.91906 14.9189 7.83816 14.898 7.76566 14.8562C7.68691 14.8107 5.81594 13.7244 3.91814 12.0876C2.79332 11.1175 1.89545 10.1553 1.24952 9.22782C0.413642 8.02763 -0.00670048 6.8732 8.07525e-05 5.79655C0.00801824 4.54374 0.456736 3.36555 1.26367 2.47899C2.08423 1.57749 3.17929 1.08105 4.3472 1.08105C5.84398 1.08105 7.21244 1.91949 8.00003 3.24768C8.78763 1.91952 10.1561 1.08105 11.6529 1.08105C12.7562 1.08105 13.809 1.52899 14.6172 2.34236C15.5042 3.23496 16.0082 4.49614 15.9999 5.80248C15.9931 6.87726 15.5649 8.02995 14.7272 9.22848C14.0792 10.1555 13.1826 11.1173 12.0622 12.0871C10.1713 13.7237 8.31381 14.81 8.23566 14.8554C8.16281 14.8977 8.08138 14.9189 8 14.9189Z" />
    </g>
  </svg>
)
export default HeartFillIcon
